module.exports = __webpack_public_path__ + "static/media/StatutesOfIIITLucknow.966dab43.pdf";